import { Spinner } from '@/components/ui/spinner';

export function InvitationAcceptance() {
  return (
    <div className="py-8 text-center">
      <Spinner size={24} className="mx-auto mb-4 text-black" />
      <p className="mb-2 text-neutral-600">Accepting invitation...</p>
      <p className="text-sm text-neutral-500">Adding you to the organization</p>
    </div>
  );
}
